import baseIndexOf from './_baseIndexOf';

/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} array The array to search.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludes(array, value) {
  return !!array.length && baseIndexOf(array, value, 0) > -1;
}

export default arrayIncludes;



//////////////////
// WEBPACK FOOTER
// ../ckeditor5-utils/src/lib/lodash/_arrayIncludes.js
// module id = null
// module chunks = 